import Modal from '@/utility/modal_triggers';
import Alert from '@/utility/alert_triggers';
import { isObject } from '@/utility/functions';

Alpine.data('alpine_cart', () => ({
  isCartLoading: false,

  async addToCart(sku, warehouse, callback) {
    this.isCartLoading = true;

    let data = new FormData();
        data.append('sku[0]', sku);
        data.append('quantity[0]', 1);
        data.append('warehouse[0]', warehouse || '03');

    await window.axios.post('/cart/add', data)
      .catch(error => {
        new Modal(error.response.data.html);
      })
      .then(response => {
        if(typeof callback === 'function') {
          callback(response);
          return;
        }

        new Modal(response.data.html);
      })
      .finally(() => this.isCartLoading = false);
  },

  async updateCartItem(item, update, callback) {
    let newItem = (isObject(update)) ? Object.assign({}, item, update) : item;

    let data = new FormData;
      data.append('_method', 'patch');
      data.append('sku', newItem.sku);
      data.append('warehouse', newItem.warehouse);
      data.append('quantity', newItem.quantity);
      data.append('note', newItem.note);
      data.append('return', 'alert');

      return await window.axios.post('/cart/update', data)
        .catch(error => {
            new Alert(error.response.data.html);
        })
        .then(response => {
          if(typeof callback === 'function') {
            callback(response);
          }

          return response;
        });
  },
}));
